import { createConsola } from 'consola';

export const logger = createConsola({
  level: 4,
});
